import axios from 'axios';
import { io } from 'socket.io-client';
import { getStorefrontStoreId } from './api';
import { getApiBaseUrl } from '../lib/storefront/storeBootstrap';
import { isAdminDashboardToken } from '../Utils/authToken';

const API_BASE_URL = getApiBaseUrl();

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token && !isAdminDashboardToken(token)) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    const storeId = getStorefrontStoreId();
    if (storeId) {
        config.headers['X-Store-Id'] = storeId;
    }
    return config;
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            window.dispatchEvent(new Event('app:auth-cleared'));
        }
        return Promise.reject(error);
    }
);

export const supportChatAPI = {
    getThread: (params) => apiClient.get('/api/support-chat/user/thread', { params }),

    sendMessage: (text, file) => {
        const formData = new FormData();
        if (text) formData.append('text', text);
        if (file) formData.append('file', file);
        return apiClient.post('/api/support-chat/user/messages', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    markRead: () => apiClient.post('/api/support-chat/user/read'),
};

export const createSupportSocket = (token) => {
    if (!token || isAdminDashboardToken(token)) {
        return null;
    }

    return io(API_BASE_URL, {
        auth: { token },
        transports: ['websocket', 'polling'],
        withCredentials: true,
        reconnection: true,
        reconnectionAttempts: 8,
        reconnectionDelay: 1000,
    });
};

export default supportChatAPI;
